import { motion } from "framer-motion";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  headingVariants,
  fadeInVariants,
  viewportSettings,
} from "../../shared/utils/animations";
import styles from "./thankyou.module.scss";

const ThankYou = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [messageType, setMessageType] = useState<
    "booking" | "purchase" | "general"
  >("general");

  useEffect(() => {
    // Check URL parameters from Vagaro redirect
    const bookingId = searchParams.get("bookingId");
    const orderId = searchParams.get("orderId");
    const status = searchParams.get("status");
    const type = searchParams.get("type");

    // Determine message type based on parameters
    if (bookingId || type === "booking" || status === "booked") {
      setMessageType("booking");
    } else if (orderId || type === "purchase" || status === "purchased") {
      setMessageType("purchase");
    }
  }, [searchParams]);

  const getHeading = () => {
    switch (messageType) {
      case "booking":
        return "Thank You for Your Booking!";
      case "purchase":
        return "Thank You for Your Purchase!";
      default:
        return "Thank You!";
    }
  };

  const getMessage = () => {
    switch (messageType) {
      case "booking":
        return "Your appointment has been confirmed. We're excited to see you at Meraki Lounge and help bring your hair goals to life!";
      case "purchase":
        return "Your purchase has been confirmed. We appreciate your business and look forward to serving you!";
      default:
        return "We appreciate your message and will get back to you soon.";
    }
  };

  const getAdditionalInfo = () => {
    const bookingId = searchParams.get("bookingId");
    const orderId = searchParams.get("orderId");

    if (bookingId) {
      return `Booking ID: ${bookingId}`;
    }
    if (orderId) {
      return `Order ID: ${orderId}`;
    }
    return null;
  };

  const additionalInfo = getAdditionalInfo();

  return (
    <div className={styles["container"]}>
      <motion.div
        initial="headingOffScreen"
        whileInView="headingOnScreen"
        viewport={viewportSettings}
        variants={headingVariants}
      >
        <h1>{getHeading()}</h1>
      </motion.div>

      <motion.div
        initial="fadeInOffScreen"
        whileInView="fadeInOnScreen"
        viewport={viewportSettings}
        variants={fadeInVariants}
      >
        <p>{getMessage()}</p>
      </motion.div>

      {additionalInfo && (
        <motion.div
          initial="fadeInOffScreen"
          whileInView="fadeInOnScreen"
          viewport={viewportSettings}
          variants={fadeInVariants}
        >
          <p className={styles["confirmation-info"]}>{additionalInfo}</p>
        </motion.div>
      )}

      <motion.div
        initial="fadeInOffScreen"
        whileInView="fadeInOnScreen"
        viewport={viewportSettings}
        variants={fadeInVariants}
      >
        <div className={styles["button-group"]}>
          <button onClick={() => navigate("/")}>Return to Home</button>
          <button
            className={styles["secondary-button"]}
            onClick={() =>
              window.open("https://www.vagaro.com/lawameraki/", "_blank")
            }
          >
            View My Booking
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default ThankYou;
